import { useState, useRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { history } from '_helpers';
import axios from 'axios';
import { Weight } from 'lucide-react';

export { Dashboard };

function Dashboard(props) {
    const { user: authUser } = useSelector(x => x.auth);
    const { users } = useSelector(x => x.users);
    
    const [centerList, setCenterList] = useState([]);
    const [doctorList, setDoctorList] = useState([]);
    
    const [pendingCount, setPendingCount] = useState(0);
    const [reviewCount, setReviewCount] = useState(0);
    const [signedoffCount, setSignedoffCount] = useState(0);
    const [printedCount, setPrintedCount] = useState(0);
    const [urgentCount, setUrgentCount] = useState(0);
    const [rewordCount, setRewordCount] = useState(0);
    const [totalCount, setTotalCount] = useState(0);

    const [todayReportC, setTodayReportC] = useState(0);
    const [todayTotalC, setTodayTotalC] = useState(0);
    const [todayPendingC, setTodayPendingC] = useState(0);
    const [yesterdayReportC, setYesterdayReportC] = useState(0);
    const [yesterdayTotalC, setYesterdayTotalC] = useState(0);
    const [yesterdayPendingC, setYesterdayPendingC] = useState(0);
    const [thismonthReportC, setThismonthReportC] = useState(0);
    const [thismonthTotalC, setThismonthTotalC] = useState(0);
    const [thismonthPendingC, setThismonthPendingC] = useState(0);
    const [thismonthHistoryPendingC, setThismonthHistoryPendingC] = useState(0);
    const [thismonthUrgentPendingC, setThismonthUrgentPendingC] = useState(0);  

    const [todayReportD, setTodayReportD] = useState(0);
    const [todayTotalD, setTodayTotalD] = useState(0);
    const [todayPendingD, setTodayPendingD] = useState(0);
    const [yesterdayReportD, setYesterdayReportD] = useState(0);
    const [yesterdayTotalD, setYesterdayTotalD] = useState(0);
    const [yesterdayPendingD, setYesterdayPendingD] = useState(0);
    const [thismonthReportD, setThismonthReportD] = useState(0);
    const [thismonthTotalD, setThismonthTotalD] = useState(0);
    const [thismonthPendingD, setThismonthPendingD] = useState(0);
    const [thismonthHistoryPendingD, setThismonthHistoryPendingD] = useState(0);
    const [thismonthUrgentPendingD, setThismonthUrgentPendingD] = useState(0);    

    const [refreshTime, setRefreshTime] = useState('');
    
    useEffect(() => {
        DashboardList();
      }, []);
     
    if(localStorage.getItem('pagename') !=="Dashboard"){
      return null;
    }
    // only show when logged in
    if (!authUser) return null;

    function randomNumberInRange(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }
    function DashboardList() {
        if(localStorage.getItem('pagename') !=="Dashboard"){
          return null;
        }
        if (!authUser) return null;

        const url = `${process.env.REACT_APP_API_URL}/dashboard`;
  
        const user_key = authUser?.user_key;
        const center_key = authUser?.center_key;

        const request_id = randomNumberInRange(1000000, 9000000);
        const token = JSON.parse(localStorage.getItem('user')).token;
        const search_flag = "";
        const config = {
          headers: {
            'content-type': 'application/json',
            'Authorization': `Bearer ${token}`,
            'user_key': user_key.toString(),
            'center_key': center_key.toString(),
            'search_flag': search_flag,
            'request_id': request_id.toString()
          },
        };
    
        try {
          
          axios.get(url, config).then((response) => {
            //console.log(response.data);
            
            //alert(JSON.stringify(response.data));
            
            let updatedCenterList = {}; let updatedDoctorList = {};
            let _pendingCount = 0; let _reviewCount = 0; let _signedoffCount = 0;
            let _printedCount = 0; let _urgentCount = 0; 
            let _rewordCount = 0; let _totalCount = 0;
  
            let _todayReportC = 0; let _todayTotalC = 0; let _todayPendingC = 0;
            let _yesterdayReportC = 0; let _yesterdayTotalC = 0; let _yesterdayPendingC = 0; 
            let _thismonthReportC = 0; let _thismonthTotalC = 0; let _thismonthPendingC = 0;
            let _thismonthHistoryPendingC = 0; let _thismonthUrgentPendingC = 0;

            let _todayReportD = 0; let _todayTotalD = 0; let _todayPendingD = 0;
            let _yesterdayReportD = 0; let _yesterdayTotalD = 0; let _yesterdayPendingD = 0; 
            let _thismonthReportD = 0; let _thismonthTotalD = 0; let _thismonthPendingD = 0;
            let _thismonthHistoryPendingD = 0; let _thismonthUrgentPendingD = 0;

            if(response.data.dashboard_center_list != null){
              updatedCenterList = response.data.dashboard_center_list; 
              updatedDoctorList = response.data.dashboard_doctor_list; 
              //const data = JSON.stringify(response.data);
              
              var summary = response.data.dashboard_summary;
              _pendingCount = summary.pending_count; 
              _reviewCount = summary.review_count; 
              _signedoffCount = summary.signedoff_count; 
              _printedCount = summary.printed_count; 
              _urgentCount = summary.urgent_count; 
              _rewordCount = summary.rework_count; 
              _totalCount = summary.total_count; 

              for (let i=0,l=updatedCenterList.length; i<l; i++) {
                _todayReportC+=updatedCenterList[i].today_report;
                _todayTotalC+=updatedCenterList[i].today_total;
                _todayPendingC+=updatedCenterList[i].today_pending;
                _yesterdayReportC+=updatedCenterList[i].yesterday_report;
                _yesterdayTotalC+=updatedCenterList[i].yesterday_total;
                _yesterdayPendingC+=updatedCenterList[i].yesterday_pending;
                _thismonthReportC+=updatedCenterList[i].thismonth_report; 
                _thismonthTotalC+=updatedCenterList[i].thismonth_total; 
                _thismonthPendingC+=updatedCenterList[i].thismonth_pending;
                _thismonthHistoryPendingC+=updatedCenterList[i].thismonth_history_pending;
                _thismonthUrgentPendingC+=updatedCenterList[i].thismonth_urgent_pending;
              }

              for (let i=0,l=updatedDoctorList.length; i<l; i++) {
                _todayReportD+=updatedDoctorList[i].today_report;
                _todayTotalD+=updatedDoctorList[i].today_total;
                _todayPendingD+=updatedDoctorList[i].today_pending;
                _yesterdayReportD+=updatedDoctorList[i].yesterday_report;
                _yesterdayTotalD+=updatedDoctorList[i].yesterday_total;
                _yesterdayPendingD+=updatedDoctorList[i].yesterday_pending;
                _thismonthReportD+=updatedDoctorList[i].thismonth_report; 
                _thismonthTotalD+=updatedDoctorList[i].thismonth_total; 
                _thismonthPendingD+=updatedDoctorList[i].thismonth_pending;
                _thismonthHistoryPendingD+=updatedDoctorList[i].thismonth_history_pending;
                _thismonthUrgentPendingD+=updatedDoctorList[i].thismonth_urgent_pending;
              }
           }

            var _time = new Date().toLocaleTimeString('en-US', {
              hour: '2-digit',
              minute: '2-digit',
              hour12: true
            });

           setCenterList(updatedCenterList); setDoctorList(updatedDoctorList);
           setRefreshTime(_time);
           setPendingCount(_pendingCount); setReviewCount(_reviewCount);
           setSignedoffCount(_signedoffCount);
           setPrintedCount(_printedCount); setUrgentCount(_urgentCount);
           setRewordCount(_rewordCount); setTotalCount(_totalCount);
           
           setTodayReportC(_todayReportC); setTodayTotalC(_todayTotalC); setTodayPendingC(_todayPendingC);
           setYesterdayReportC(_yesterdayReportC); setYesterdayTotalC(_yesterdayTotalC); setYesterdayPendingC(_yesterdayPendingC);
           setThismonthReportC(_thismonthReportC); setThismonthTotalC(_thismonthTotalC); setThismonthPendingC(_thismonthPendingC);
           setThismonthHistoryPendingC(_thismonthHistoryPendingC);
           setThismonthUrgentPendingC(_thismonthUrgentPendingC);

           setTodayReportD(_todayReportD); setTodayTotalD(_todayTotalD); setTodayPendingD(_todayPendingD);
           setYesterdayReportD(_yesterdayReportD); setYesterdayTotalD(_yesterdayTotalD); setYesterdayPendingD(_yesterdayPendingD);
           setThismonthReportD(_thismonthReportD); setThismonthTotalD(_thismonthTotalD); setThismonthPendingD(_thismonthPendingD);
           setThismonthHistoryPendingD(_thismonthHistoryPendingD);
           setThismonthUrgentPendingD(_thismonthUrgentPendingD);

           setTimeout(function() {
            DashboardList();
          }, 60000);
           
          });
        } catch (err) {
          //debugger;
          //alert('error');
            //alert(err.code);
          if (err.code === '404') {
            //setError('Object does not exist.')
            return
          }
        }
    
      }
  
      function sortClick(event, col_name)
      {
          ;
      }  
    function printClick()
    {
        ;
    }

    const closeClick = (event) => {
        history.navigate('/home');
    };

    
    return (
        <>
            <main>
              <div className="container-fluid px-4">
                <div className="row">
                  <div className="col-12 col-lg-10 col-md-10 col-sm-6 mt-2">
                    <h5 className="text-blue font-roboto font-weight700">Dashboard</h5>
                  </div>
                  
                  <div className="col-12 col-lg-2 col-md-2 col-sm-6 mt-2 mb-1">
                    <button type="button" className="btn btn-grey btn-sm btn-block bi" id="btnlastrefresh">
                      Last Refresh: {refreshTime}</button>
                  </div>
                </div>

                <hr className="mt-0" />

                {/* -- Dashboard Start -- */}
                <div className="row">
                  <div className="col-6 col-lg-2 col-md-3 col-sm-6 mb-2">
                    <div className="card">
                      <div className="card-header dashboard-head-pending text-light text-center"><small>Pending </small></div>
                      <div className="card-body-dashbaord dashboard-pending text-center height-70">
                        <h3><i className="bi bi-file-earmark-medical-fill icon icon-pending"></i> {pendingCount}</h3>

                      </div>
                    </div>
                  </div>

                  {(reviewCount > 0  ? 
                      <div className="col-6 col-lg-2 col-md-3 col-sm-6 mb-2">
                        <div className="card">
                          <div className="card-header dashboard-head-review text-light text-center"><small>Review </small></div>
                          <div className="card-body-dashbaord dashboard-review text-center height-70">
                            <h3><i className="bi bi-clipboard2-check icon icon-review"></i> {reviewCount}</h3>
                          </div>
                        </div>
                      </div>
                    : <div style={{display:"none"}}></div>
                  )}

                  <div className="col-6 col-lg-2 col-md-3 col-sm-6 mb-2">
                    <div className="card">
                      <div className="card-header dashboard-head-signedoff text-light text-center"><small>Signed Off </small></div>
                      <div className="card-body-dashbaord dashboard-signedoff text-center height-70">
                        <h3><i className="bi bi-clipboard2-pulse-fill icon icon-signedoff"></i> {signedoffCount}</h3>
                      </div>
                    </div>
                  </div>
                  
                  {(reviewCount === 0  ? 
                      <div className="col-6 col-lg-2 col-md-3 col-sm-6 mb-2">
                        <div className="card">
                          <div className="card-header dashboard-head-printed text-light text-center"><small>Printed </small></div>
                          <div className="card-body-dashbaord dashboard-printed text-center height-70">
                            <h3><i className="bi bi-printer-fill icon icon-printed"></i> {printedCount}</h3>
                          </div>
                        </div>
                      </div>
                    : <div style={{display:"none"}}></div>
                  )}

                  <div className="col-6 col-lg-2 col-md-3 col-sm-6 mb-2">
                    <div className="card">
                      <div className="card-header dashboard-head-urgent text-light text-center"><small>Urgent </small></div>
                      <div className="card-body-dashbaord dashboard-urgent text-center height-70">
                        <h3><i className="bi bi-heart-pulse-fill icon icon-urgent"></i> {urgentCount}</h3>
                      </div>
                    </div>
                  </div>

                  <div className="col-6 col-lg-2 col-md-3 col-sm-6 mb-2">
                    <div className="card">
                      <div className="card-header dashboard-head-rework text-light text-center"><small>Rework </small></div>
                      <div className="card-body-dashbaord dashboard-rework text-center height-70">
                        <h3><i className="bi bi-file-earmark-medical-fill icon icon-rework"></i> {rewordCount}</h3>
                      </div>
                    </div>
                  </div>

                  <div className="col-6 col-lg-2 col-md-3 col-sm-6 mb-2">
                    <div className="card">
                      <div className="card-header dashboard-head-total text-light text-center"><small>Total </small></div>
                      <div className="card-body-dashbaord dashboard-total text-center height-70">
                        <h3><i className="bi bi-file-earmark-bar-graph icon icon-total"></i> {totalCount}</h3>
                      </div>
                    </div>
                  </div>

                </div>

                {/* -- Grid Data -- */}
                <div className="row">
 
                  <div className={`${authUser?.user_type === 'A' || authUser?.user_type === 'S' ? "col-md-6 mb-2" : "col-md-12 mb-2"}`}>
                    <div className="tab-content" id="myTabCenter">
                      <div className="tab-pane fade show active mt-2" id="all-tab-pane" role="tabpanel" aria-labelledby="all-tab"
                        tabindex="0">
                        <div className="card">
                          <div className="card-header bg-gradient-1 text-light">
                            {/* -- Table Heading -- */}
                            <div className="row">
                              <div className="col-4 col-sm-6 col-md-d-list">
                                <p className="tele-table-dash-heading">Center List</p>
                              </div>
                              <div className="col-4 col-sm-1 col-md-d-total text-right">
                                <p className="tele-table-dash-heading">Today </p>
                              </div>
                              <div className="col-4 col-sm-1 col-md-d-pending text-right">
                                <p className="tele-table-dash-heading">Pending </p>
                              </div>
                              <div className="col-4 col-sm-1 col-md-d-total d-none d-sm-block text-right">
                                <p className="tele-table-dash-heading">Yesterday </p>
                              </div>
                              <div className="col-4 col-sm-1 col-md-d-pending d-none d-sm-block text-right">
                                <p className="tele-table-dash-heading">Pending </p>
                              </div>
                              <div className="col-4 col-sm-1 col-md-d-total text-right">
                                <p className="tele-table-dash-heading">This Month</p>
                              </div>
                              <div className="col-4 col-sm-1 col-md-d-pending d-none d-sm-block text-right d-lg-none">
                                <p className="tele-table-dash-heading">Pending </p>
                              </div>
                            </div>
                          </div>
                          <div className="card-body tele-table-padding dash-studylist-area">
                            {/* -- tele-table-rowbg1 -- */}

                            {Object.keys(centerList).map((data, i) => ( 
                              (centerList[i].thismonth_total > 0 ? 
                                <div key={i} className="row studylist">
                                  <div className="col-4 col-sm-6 col-md-d-list">
                                    {(authUser?.user_type === 'D' || authUser?.user_type === 'R' ? 
                                            <p className="tele-table-dash-text">{centerList[i].center_name}</p>
                                          : <p className="tele-table-dash-text">{centerList[i].center_id} : {centerList[i].center_name}</p>
                                    )}
                                    <p className="tele-table-dash-text text-bold">
                                      {centerList[i].thismonth_history_pending>0 ? " History/Wait="+centerList[i].thismonth_history_pending : ""}
                                      {centerList[i].thismonth_urgent_pending>0 ? " Urgent="+centerList[i].thismonth_urgent_pending : ""}
                                    </p>
                                  </div>
                                  <div className="col-4 col-sm-1 col-md-d-total text-right">
                                    <p className="tele-table-dash-text">{centerList[i].today_total}<span style={{fontSize: "9px"}}>/{centerList[i].today_report}</span></p>
                                  </div>
                                  <div className="col-4 col-sm-1 col-md-d-pending text-right">
                                    <p className="tele-table-dash-text">{centerList[i].today_pending}
                                    </p>
                                  </div>
                                  <div className="col-4 col-sm-1 col-md-d-total d-none d-sm-block text-right">
                                    <p className="tele-table-dash-text">{centerList[i].yesterday_total}<span style={{fontSize: "9px"}}>/{centerList[i].yesterday_report}</span></p>
                                  </div>
                                  <div className="col-4 col-sm-1 col-md-d-pending d-none d-sm-block text-right">
                                    <p className="tele-table-dash-text">{centerList[i].yesterday_pending}</p>
                                  </div>
                                  <div className="col-4 col-sm-1 col-md-d-total text-right">
                                    <p className="tele-table-dash-text">{centerList[i].thismonth_total}<span style={{fontSize: "9px"}}>/{centerList[i].thismonth_report}</span></p>
                                  </div>
                                  <div className="col-4 col-sm-1 col-md-d-pending d-none d-sm-block text-right d-lg-none">
                                    <p className="tele-table-dash-text">{centerList[i].thismonth_pending}</p>
                                  </div>
                                </div>
                                : <span></span>
                              )
                                  

                            ))}
                          </div>

                          <div className="card-header bg-gradient-1 text-light">
                            {/* -- Table Footer Heading -- */}
                            <div className="row">
                              <div className="col-4 col-sm-6 col-md-d-list">
                                <p className="tele-table-dash-heading">Total: 
                                  {thismonthHistoryPendingC+thismonthUrgentPendingC>0 ? " (": ""}
                                  {thismonthHistoryPendingC>0 ? "History/Wait="+thismonthHistoryPendingC: ""}
                                  {thismonthUrgentPendingC>0 ? " Urgent="+thismonthUrgentPendingC: ""}
                                  {thismonthHistoryPendingC+thismonthUrgentPendingC>0 ? ")": ""}
                                </p>
                              </div>
                              <div className="col-4 col-sm-1 col-md-d-total text-right">
                                <p className="tele-table-dash-heading">{todayTotalC}<span style={{fontSize: "9px"}}>/{todayReportC}</span></p>
                              </div>
                              <div className="col-4 col-sm-1 col-md-d-pending text-right">
                                <p className="tele-table-dash-heading">{todayPendingC} </p>
                              </div>
                              <div className="col-4 col-sm-1 col-md-d-total d-none d-sm-block text-right">
                                <p className="tele-table-dash-heading">{yesterdayTotalC}<span style={{fontSize: "9px"}}>/{yesterdayReportC}</span></p>
                              </div>
                              <div className="col-4 col-sm-1 col-md-d-pending d-none d-sm-block text-right">
                                <p className="tele-table-dash-heading">{yesterdayPendingC} </p>
                              </div>
                              <div className="col-4 col-sm-1 col-md-d-total text-right">
                                <p className="tele-table-dash-heading">{thismonthTotalC}<span style={{fontSize: "9px"}}>/{thismonthReportC}</span></p>
                              </div>
                              <div className="col-4 col-sm-1 col-md-d-pending d-none d-sm-block text-right d-lg-none">
                                <p className="tele-table-dash-heading">{thismonthPendingC} </p>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>

                  <div className={`${authUser?.user_type === 'A' || authUser?.user_type === 'S' ? "col-md-6 mb-2" : "col-md-12 mb-2"}`}>
                    <div className={`tab-content ${authUser?.user_type === 'A' || authUser?.user_type === 'S' ? "" : "d-none"}`} id="myTabDoctor">
                      <div className="tab-pane fade show active mt-2" id="all-tab-pane" role="tabpanel" aria-labelledby="all-tab"
                        tabindex="0">
                        <div className="card">
                          <div className="card-header bg-gradient-1 text-light">
                            {/* -- Table Heading -- */}
                            <div className="row">
                              <div className="col-4 col-sm-6 col-md-d-list">
                                <p className="tele-table-dash-heading">Doctor List</p>
                              </div>
                              <div className="col-4 col-sm-1 col-md-d-total text-right">
                                <p className="tele-table-dash-heading">Today </p>
                              </div>
                              <div className="col-4 col-sm-1 col-md-d-pending text-right">
                                <p className="tele-table-dash-heading">Pending </p>
                              </div>
                              <div className="col-4 col-sm-1 col-md-d-total d-none d-sm-block text-right">
                                <p className="tele-table-dash-heading">Yesterday </p>
                              </div>
                              <div className="col-4 col-sm-1 col-md-d-pending d-none d-sm-block text-right">
                                <p className="tele-table-dash-heading">Pending </p>
                              </div>
                              <div className="col-4 col-sm-1 col-md-d-total text-right">
                                <p className="tele-table-dash-heading">This Month</p>
                              </div>
                              <div className="col-4 col-sm-1 col-md-d-pending d-none d-sm-block text-right d-lg-none">
                                <p className="tele-table-dash-heading">Pending </p>
                              </div>
                            </div>
                          </div>
                          <div className="card-body tele-table-padding dash-studylist-area">
                            {/* -- tele-table-rowbg1 -- */}

                            {Object.keys(doctorList).map((data, i) => ( 
                              (doctorList[i].thismonth_total > 0 ? 
                                <div key={i} className="row studylist">
                                  <div className="col-4 col-sm-6 col-md-d-list">
                                    {(authUser?.user_type === 'D' ? 
                                            <p className="tele-table-dash-text">{doctorList[i].doctor_name}</p>
                                          : <p className="tele-table-dash-text">{doctorList[i].doctor_id} : {doctorList[i].doctor_name}</p>
                                    )}
                                    <p className="tele-table-dash-text text-bold">
                                      {doctorList[i].thismonth_history_pending>0 ? " History/Wait="+doctorList[i].thismonth_history_pending : ""}
                                      {doctorList[i].thismonth_urgent_pending>0 ? " Urgent="+doctorList[i].thismonth_urgent_pending : ""}
                                    </p>
                                  </div>
                                  <div className="col-4 col-sm-1 col-md-d-total text-right">
                                    <p className="tele-table-dash-text">{doctorList[i].today_total}<span style={{fontSize: "9px"}}>/{doctorList[i].today_report}</span></p>
                                  </div>
                                  <div className="col-4 col-sm-1 col-md-d-pending text-right">
                                    <p className="tele-table-dash-text">{doctorList[i].today_pending}
                                    </p>
                                  </div>
                                  <div className="col-4 col-sm-1 col-md-d-total d-none d-sm-block text-right">
                                    <p className="tele-table-dash-text">{doctorList[i].yesterday_total}<span style={{fontSize: "9px"}}>/{doctorList[i].yesterday_report}</span></p>
                                  </div>
                                  <div className="col-4 col-sm-1 col-md-d-pending d-none d-sm-block text-right">
                                    <p className="tele-table-dash-text">{doctorList[i].yesterday_pending}</p>
                                  </div>
                                  <div className="col-4 col-sm-1 col-md-d-total text-right">
                                    <p className="tele-table-dash-text">{doctorList[i].thismonth_total}<span style={{fontSize: "9px"}}>/{doctorList[i].thismonth_report}</span></p>
                                  </div>
                                  <div className="col-4 col-sm-1 col-md-d-pending d-none d-sm-block text-right d-lg-none">
                                    <p className="tele-table-dash-text">{doctorList[i].thismonth_pending}</p>
                                  </div>
                                </div>
                                : <span></span>
                              )
                                  

                            ))}
                          </div>

                          <div className="card-header bg-gradient-1 text-light">
                            {/* -- Table Footer Heading -- */}
                            <div className="row">
                              <div className="col-4 col-sm-6 col-md-d-list">
                                <p className="tele-table-dash-heading">Total:
                                  {thismonthHistoryPendingD+thismonthUrgentPendingD>0 ? " (": ""}
                                  {thismonthHistoryPendingD>0 ? "History/Wait="+thismonthHistoryPendingD: ""}
                                  {thismonthUrgentPendingD>0 ? " Urgent="+thismonthUrgentPendingD: ""}
                                  {thismonthHistoryPendingD+thismonthUrgentPendingD>0 ? ")": ""}                                  
                                </p>
                              </div>
                              <div className="col-4 col-sm-1 col-md-d-total text-right">
                                <p className="tele-table-dash-heading">{todayTotalD}<span style={{fontSize: "9px"}}>/{todayReportD}</span></p>
                              </div>
                              <div className="col-4 col-sm-1 col-md-d-pending text-right">
                                <p className="tele-table-dash-heading">{todayPendingD} </p>
                              </div>
                              <div className="col-4 col-sm-1 col-md-d-total d-none d-sm-block text-right">
                                <p className="tele-table-dash-heading">{yesterdayTotalD}<span style={{fontSize: "9px"}}>/{yesterdayReportD}</span></p>
                              </div>
                              <div className="col-4 col-sm-1 col-md-d-pending d-none d-sm-block text-right">
                                <p className="tele-table-dash-heading">{yesterdayPendingD} </p>
                              </div>
                              <div className="col-4 col-sm-1 col-md-d-total text-right">
                                <p className="tele-table-dash-heading">{thismonthTotalD}<span style={{fontSize: "9px"}}>/{thismonthReportD}</span></p>
                              </div>
                              <div className="col-4 col-sm-1 col-md-d-pending d-none d-sm-block text-right d-lg-none">
                                <p className="tele-table-dash-heading">{thismonthPendingD} </p>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>

                </div>

              </div>
            </main>

            {users.loading && <div className="spinner-border spinner-border-sm"></div>}
            {users.error && <div className="text-danger">Error loading users: {users.error.message}</div>}

        </>
    );
}
